export default {
      id: "oc-res-bill-monthlydetail-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-bill-monthlydetail",
      toString: function () {
        return this.url;
      }
    }